module.exports = __webpack_public_path__ + "static/img/merchant_feature_8.ab5edf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_feature_8.png
// module id = we5/
// module chunks = 8